<template>
  <section>
    <!-- <div style="height:50px;background: -webkit-gradient(linear,left top,left bottom,from(#eff2f8),to(#fff));"></div> -->
    <div class="container">
      <!-- 热门币种 -->
      <new-markets :hotMarkets="hotMarkets"></new-markets>
      <!-- 行情 -->
      <div class="home_main">
        <!-- 市场分类 -->
        <nav class="nav_first">
          <div class="parentElement">
            <!-- type="border-card" -->
            <!-- 市场导航 -->
            <el-tabs
              type="border-card"
              v-model="navFirstActive"
              @tab-click="marketClick"
            >
              <el-tab-pane
                v-for="(v, k) in navFirst"
                :disabled="v.index == '999'"
                :key="k"
                :label="$t(v.name)"
                :name="'nav' + v.index"
              >
                <span v-if="v.index == '-2'" slot="label">
                  <i class="icon-star_empty"></i>
                  {{ $t('home.favorites') }}
                </span>
                <!-- 将搜索插到tabs里面 -->
                <div
                  v-if="v.index == '999'"
                  slot="label"
                  class="hidden-sm-and-down"
                >
                  <div class="custom">
                    <!-- 模式币 -->
                    <div class="custom-main" v-if="mainSite">
                      <el-dropdown
                        @command="handleCommand"
                        :hide-on-click="false"
                        v-if="customTags.isCustom"
                        class="custom-menu"
                      >
                        <span class="el-dropdown-link">
                          {{ $t('home.classify') }}
                          <i class="el-icon-caret-bottom el-icon--right"></i>
                        </span>
                        <!-- 标签列表 -->
                        <el-dropdown-menu slot="dropdown">
                          <el-checkbox-group v-model="customTags.selectTags">
                            <el-dropdown-item
                              v-for="(v, k) in coinTags"
                              :key="k"
                              :command="v.name"
                            >
                              <el-checkbox
                                @change="coinsTagsChange"
                                :label="v.name"
                                :key="k"
                                >{{ v.name }}</el-checkbox
                              >
                              <!-- <el-badge class="mark" :value="v.coins.length+'币种'" type="info" /> -->
                              <small
                                style="
                                  color: #909399;
                                  margin-left: 10px;
                                  text-align: center;
                                "
                                >({{
                                  v.coins.length + ' ' + $t('trade.coin')
                                }})</small
                              >
                            </el-dropdown-item>
                          </el-checkbox-group>
                        </el-dropdown-menu>
                      </el-dropdown>

                      <!-- 分类开关 -->
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="$t('home.text_01')"
                        placement="top"
                      >
                        <el-switch
                          @change="coinsTagsChange"
                          v-model="customTags.isCustom"
                        ></el-switch>
                      </el-tooltip>
                    </div>
                    <!-- 搜索交易区 -->
                    <el-input
                      size="mini"
                      v-model="search"
                      :placeholder="
                        $t('search.search') +
                        ' ' +
                        (activeName === 'optional'
                          ? $t('home.favorites')
                          : activeName + ' ' + $t('home.markets'))
                      "
                      clearable
                      prefix-icon="el-icon-search"
                    ></el-input>
                  </div>
                </div>
                <!-- 交易区导航 -->
                <el-tabs
                  v-if="getMarkets.length != 0"
                  class="nav_second"
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane
                    v-for="(v, k) in getMarkets"
                    :key="v + k"
                    :label="v + ' ' + $t('home.markets')"
                    :name="v"
                  ></el-tab-pane>
                </el-tabs>
              </el-tab-pane>
            </el-tabs>
          </div>
        </nav>
        <!-- 行情 -->
        <div class="market_body">
          <el-main>
            <!-- :default-sort="{ prop: 'baseVol', order: 'descending' }" -->
            <el-table
              v-loading="loading"
              @row-click="goExchange"
              @cell-click="handle"
              ref="tickersTable"
              :data="orderTickers"
              style="width: 100%"
              row-class-name="cell_style"
            >
              <template slot="empty">
                <i class="icon-no-data"></i>
                <p>{{ $t('trade.notData') }}</p>
              </template>

              <el-table-column width="30">
                <template slot="header" slot-scope="scope">
                  <i class="icon-star_empty"></i>
                </template>
                <template slot-scope="scope">
                  <i
                    class="fa fa-fw"
                    :class="scope.row.star ? 'icon-star' : 'icon-star_empty'"
                    style="width: 100%; cursor: pointer"
                    @click.stop="setfavorites(scope.row.pair)"
                  ></i>
                </template>
              </el-table-column>

              <el-table-column
                prop="pair"
                :label="$t('trade.symbols')"
                width="180"
                sortable
              >
                <template slot-scope="scope">
                  <div style="white-space: nowrap">
                    <i class="iconCoin">
                      <img
                        :src="getCoinIcon($common.getCoin(scope.row.pair))"
                        :alt="scope.row.pair"
                      />
                    </i>
                    <span
                      style="
                        display: inline-block;
                        vertical-align: middle;
                        line-height: 1.2;
                      "
                    >
                      <p>{{ scope.row.pair | toString }}</p>
                      <small style="white-space: nowrap; color: #909399">
                        {{
                          coins[$common.getCoin(scope.row.pair)]
                            | getDictValue('chineseName')
                        }}
                        <el-tag
                          v-if="scope.row.tags && mainSite"
                          v-for="(v, k) in scope.row.tags"
                          :key="k"
                          style="
                            margin-left: 3px;
                            height: auto;
                            padding: 2px;
                            line-height: 1;
                          "
                          effect="plain"
                          size="mini"
                          >{{ v }}</el-tag
                        >
                      </small>
                    </span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="last"
                :label="$t('trade.entrustPrice')"
                sortable
              >
                <template slot-scope="scope">
                  <span style="line-height: 1">
                    <span :class="tickersColor(scope.row.change || 0)">{{
                      (scope.row.last || 0) | autoNumber
                    }}</span>
                    <i :class="tickersColor(scope.row.change || 0, 'icon')"></i>
                    <p class="cn_name" style="font-size: 12px; color: #c0c4cc">
                      {{ getValuation(scope.row.last, scope.row) }}
                    </p>
                  </span>
                </template>
              </el-table-column>

              <el-table-column
                prop="change"
                :label="$t('trade.applies')"
                sortable
              >
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.change >= 0 ? 'success' : 'danger'"
                    style="width: 80px; text-align: center; border: none"
                  >
                    <span :class="tickersColor(scope.row.change || 0)"
                      >{{ (scope.row.change || 0) | toFixedEx(2) }}%</span
                    >
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="low"
                :label="$t('trade.minimumPrice')"
                sortable
              >
                <template slot-scope="scope">
                  <span>{{ (scope.row.low || 0) | autoNumber }}</span>
                </template>
              </el-table-column>

              <el-table-column
                prop="hight"
                :label="$t('trade.highestPrice')"
                sortable
              >
                <template slot-scope="scope">
                  <span>{{ (scope.row.hight || 0) | autoNumber }}</span>
                </template>
              </el-table-column>

              <el-table-column
                prop="vol"
                :label="$t('trade.dealVolume')"
                sortable
              >
                <template slot-scope="scope">
                  <span>{{ (scope.row.vol || 0) | autoNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="baseVol"
                :label="$t('trade.H_turnover')"
                sortable
              >
                <template slot-scope="scope">
                  <span>{{ (scope.row.baseVol || 0) | autoNumber }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" width="100" align="center">
                  <template template slot-scope="scope">
                    <el-button size="mini">交易</el-button>
                  </template>
              </el-table-column>-->
            </el-table>
          </el-main>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import exchangeApi from '@/api/exchange';
import newMarkets from './newMarket';
import { mapState } from 'vuex';
import config from '@/config';
import _ from 'lodash';
import vClassify from './classify';
import baseApi from '@/api/base';
import { stat } from 'fs';

export default {
  name: 'home',
  components: {
    newMarkets,
    vClassify,
  },
  data() {
    return {
      customTags: {
        //自定义显示交易对
        isCustom: false,
        selectTags: [],
      },
      search: '',
      loading: false,
      tabs: [],
      navFirstActive: 'nav-1',
      tickers: null,
      activeName: null,
      favorites: [], //自选币种
      isLoadFavorites: false, //是否加载了自选
      tickerTimer: null,
      destroy: false, //定时器
      hotMarkets: [], //热门币种
      mainSite: config.coinTags,
    };
  },
  // 计算属性
  computed: {
    ...mapState([
      'coins',
      'isLogin',
      'markets',
      'webTitle',
      'appLogo',
      'appVersion',
      'coinsTags',
    ]),
    // 市场分类导航
    navFirst() {
      let types = _.clone(this.marketTypes) || [];
      let list = [];
      let indexs = [];

      for (let item of types) {
        let index = '';
        if (
          (item['types'] && item['types']['index']) ||
          item['types']['index'] === 0
        ) {
          index = item['types']['index'];
        }
        if (item['types'] && index !== '' && indexs.indexOf(index) == -1) {
          list.push(item['types']);
          indexs.push(index);
        }
      }

      // 创业区和自选区
      for (let item of [
        { index: '-1', name: 'main.allMarkets' },
        { index: '-2', name: 'home.favorites' },
        { index: '999', name: '' },
      ]) {
        list.push(item);
      }

      // 排序
      var compare = function (obj1, obj2) {
        var val1 = Number(obj1.index);
        var val2 = Number(obj2.index);
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
      list.sort(compare);

      return list;
    },
    // 提取市场分类
    marketTypes() {
      let list = [];
      for (let item of this.markets) {
        if (item.types) {
          list.push(item);
        }
      }

      return list;
    },

    // 获取base币种
    getMarkets() {
      let markets = _.clone(this.tabs);
      let baseCoinList = [];

      // 判断当前选择的分类
      if (this.navFirstActive == 'nav-1') {
        baseCoinList =
          this.markets.length > 0
            ? this.markets
            : this.$common.getJsonData(localStorage.baseCoinList || '[]');
      } else {
        for (let item of this.marketTypes) {
          let num = this.navFirstActive.replace('nav', '');
          if (item['types']['index'] == num && item['isTrade']) {
            baseCoinList.push(item);
          }
        }
      }

      for (let item of baseCoinList) {
        if (isNaN(item['index'])) {
          item['index'] = 0;
        }
      }

      baseCoinList.sort(function (a, b) {
        return a.index - b.index;
      });

      //  // 交易区排序
      //   baseCoinList.sort(function(a, b) {
      //     return a.index() > b.index? 1 : -1;
      //   });

      for (let item of baseCoinList) {
        if (markets.indexOf(item.base) == -1) {
          markets.push(item.base);
        }
      }

      // 默认选中
      this.$nextTick(() => {
        if (markets[0]) {
          this.activeName = markets[0];
        }
      });

      return markets;
    },
    //所有标签 重构一下标签数据
    coinTags() {
      let coins = this.coins;
      let coinsTags = this.coinsTags;
      let data = [];

      for (let item of coinsTags) {
        data.push({
          name: item,
          coins: [],
        });
      }
      for (let item in coins) {
        // 循坏用户选择的模式
        for (let i of data) {
          if (coins[item].tags && coins[item].tags.indexOf(i.name) != -1) {
            i.coins.push(item);
          }
        }
      }
      return data;
    },
    // 从币种里面读取出对应的标签
    getTagsCoin() {
      let coins = this.coins;
      let data = [];

      for (let coin in coins) {
        // 循坏用户选择的模式
        for (let item of this.customTags.selectTags) {
          if (coins[coin].tags && coins[coin].tags.indexOf(item) != -1) {
            //判断当币种不存在的时候才添加
            if (data.indexOf(coins[coin].coin) == -1) {
              data.push(coin);
            }
          }
        }
      }
      return data;
    },

    tickerList() {
      let marketTypes = this.marketTypes; //市场分类
      let _marketActive = this.navFirstActive.replace('nav', '');
      let list = [];

      //   热门币种
      let hotMarkets = [];
      //   自选币种
      let favorites = this.favorites
        ? this.favorites
        : this.$common.getJsonData(localStorage.favorites || '[]');
      // 自选图标
      for (let pair in this.tickers) {
        this.tickers[pair].star = null;
      }
      // 自选币种
      favorites.forEach((pair) => {
        if (this.tickers[pair]) {
          this.tickers[pair].star = 1;
        }
      });

      // 添加市场分类
      for (let item of marketTypes) {
        let pair = item.coin + '_' + item.base;
        if (pair && this.tickers) {
          if (this.tickers[pair]) {
            this.tickers[pair]['types'] = item.types;
            // this.$set(this.tickers[pair], "types", item.types);
          }
        }
      }
      // 提取index排序
      for (let item of this.markets) {
        let pair = item.coin + '_' + item.base;
        if (pair && this.tickers) {
          if (this.tickers[pair]) {
            this.tickers[pair]['index'] = item.index;
            // this.$set(this.tickers[pair], "types", item.types);
          }
        }
      }

      // 处理交易对
      for (let pair in this.tickers) {
        // 提取热门交易对
        hotMarkets.push(this.tickers[pair]);

        // 将字符串数据转换成数字,方便排序
        for (let key in this.tickers[pair]) {
          if (!isNaN(Number(this.tickers[pair][key]))) {
            this.tickers[pair][key] = Number(this.tickers[pair][key]);
          }
        }

        // 获取当前交易对的types
        let _type = this.tickers[pair]['types']
          ? this.tickers[pair]['types']['index']
          : '';
        let info = this.getExchangeInfo(pair);

        // 全部行情
        if (_marketActive == '-1') {
          list = this.getTagsMarkets(pair, list, info);
        }

        // 自选
        else if (_marketActive == '-2' && favorites.indexOf(pair) != -1) {
          list.push(this.tickers[pair]);
        }
        // 市场
        else if (_type == _marketActive) {
          list = this.getTagsMarkets(pair, list, info);
        }
      }
      // 排序
      const dataSort = (a, b) => {
        /**
         * 先按index排序从小到大
         * 再按baseVol排序从大到小
         */
        if (a['index'] != b['index']) {
          return a.index - b.index;
        } else if (a.baseVol != b.baseVol) {
          return b.baseVol - a.baseVol;
        }
        // return b.baseVol - a.baseVol;
      };
      // 热门币种排序
      hotMarkets.sort(dataSort);
      this.hotMarkets = hotMarkets;
      // .slice(0,5)
      return list.sort(dataSort);
    },
    // 模糊搜索
    orderTickers() {
      let newObj = [];

      for (let item of this.tickerList) {
        try {
          if (
            item.pair &&
            this.$common
              .getCoin(item.pair)
              .indexOf(this.search.toUpperCase().trim()) > -1
          ) {
            newObj.push(item);
          }
        } catch (e) {}
      }

      return newObj;
    },
  },
  // 默认加载
  mounted() {
    if (this.mainSite) {
      this.$store.commit('getCoinsTags');
    }

    this.getFavorites();
    this.tickers = this.$common.getJsonData(localStorage.tickers) || {};

    try {
      if (Object.keys(this.tickers).length <= 0) {
        this.loading = true;
      }
    } catch (e) {}

    //获取行情
    this.getTickers();
  },
  destroyed() {
    //清除定时器
    clearTimeout(this.tickerTimer);
    this.destroy = true; //当离开页面的时候就不再执行定时器
    window.removeEventListener('scroll', this.handleScroll);
  },
  created() {
    if (localStorage.getItem('customTags') != null) {
      this.customTags = JSON.parse(localStorage.getItem('customTags')) || {};
    }
  },
  methods: {
    // 筛选标签分类
    getTagsMarkets(pair, list, info) {
      let _tagsCoin = this.getTagsCoin; //选择的模式币种
      let _coins = this.coins;
      let _activeName = this.activeName;
      if (_activeName && _activeName.indexOf(pair.split('_')[1]) != -1) {
        // 将币种标签提取到行情列表里面
        for (let coin in _coins) {
          if (_coins[coin].tags && coin == this.$common.getCoin(pair)) {
            this.tickers[pair]['tags'] = _coins[coin].tags;
          }
        }
        // 如果是主站就执行模式币筛选
        if (this.mainSite && this.customTags.isCustom) {
          for (let item of _tagsCoin) {
            //  -----!info.type
            if (info && item == info['coin']) {
              list.push(this.tickers[pair]);
            }
          }
        } else {
          // -----!info.type
          if (info) {
            list.push(this.tickers[pair]);
          }
        }
      }
      return list;
    },
    // 标签币种选择
    coinsTagsChange(state, item) {
      let data = {
        isCustom: this.customTags.isCustom,
        selectTags: this.customTags.selectTags || [],
      };
      localStorage.setItem('customTags', JSON.stringify(data));
    },
    handleCommand(command) {
      // this.selectTags=command;
    },
    // 获取数据
    async getTickers() {
      // this.tickers = this.$common.getJsonData(localStorage.tickers || "{}");

      let _getTickers = () => {
        if (!this.destroy) {
          this.tickerTimer = setTimeout(async () => {
            await this.getTickers();
          }, 1000 * 5);
        }
      };

      try {
        let tickers = await exchangeApi.getTickers();
        this.loading = false;
        for (let item in tickers) {
          tickers[item].pair = item;
        }
        this.tickers = tickers;
        localStorage.setItem('tickers', JSON.stringify(this.tickers));
        _getTickers();
      } catch (e) {
        _getTickers();
      }
    },
    // 设置自选币种
    async setfavorites(pair) {
      if (!pair) return;
      if (!this.isLogin()) return this.$router.push('/login');
      let favorites = this.favorites;
      //   取消自选
      if (this.favorites.indexOf(pair) != -1) {
        //  _.pull(favorites, pair);
        let n = 0;
        for (let item of this.favorites) {
          if (item == pair) {
            this.favorites.splice(n, 1);
          }
          n++;
        }

        try {
          let result = await exchangeApi.unsetfavorites({
            market: pair,
          });
          this.$notify.success(this.$t('financial.setSuccess'));
        } catch (e) {}
      }
      //   添加自选
      else {
        favorites.push(pair);

        try {
          let result = await exchangeApi.setfavorites({
            market: pair,
          });
          this.$notify.success(this.$t('financial.setSuccess'));
        } catch (e) {}
      }
    },
    // 获取自选
    async getFavorites() {
      if (!this.isLogin()) return;
      let result = await exchangeApi.getFavorites();
      this.favorites = result;
      this.isLoadFavorites = true;
      localStorage.favorites = JSON.stringify(result);
    },
    // 去交易中心
    goExchange(row, column, event) {
      if (!row) return;
      this.$router.push({
        path: `/exchange/${row.pair}`,
      });
    },
    marketClick(tab, event) {
      this.navFirstActive = tab.name;
      if (tab.name == 'nav-2' && !this.isLoadFavorites) {
        this.getFavorites(); //获取自选币种
      }
    },
    // 切换交易区
    handleClick(tab, event) {
      this.activeName = tab.name;
    },
    // 单元格点击
    handle(row, column, event, cell) {
      console.log(row, column, event, cell);
    },
    //获取交易对配置信息
    getExchangeInfo(market) {
      for (let item of this.markets) {
        if (market == item['coin'] + '_' + item['base']) {
          return item;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nav_first {
  //   height: 50px;
  //   line-height: 50px;
  overflow: hidden;
  //   padding: 0 10px;
  /deep/ .el-tabs--border-card > .el-tabs__content {
    padding: 0 15px;
  }
  /deep/ .el-tabs--border-card {
    border: none;
  }
  /deep/ .el-tabs--border-card > .el-tabs__header {
    border: none;
  }
  /deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-left-color: transparent;
    border-right-color: transparent;
  }
  /deep/ .el-tabs--border-card {
    background-color: transparent;
  }
  //   搜索框
  /deep/ .el-tabs__nav {
    float: none;
    // width: 100%;
    // overflow: hidden;
    /deep/ #tab-nav999 {
      float: right;
    }
  }
}

.nav_second {
  width: 100%;
  height: 60px;
  line-height: 60px;
}
.market_body {
  padding: 0 10px;
}
// .imgIcon{
//   width: 70px; height: 50px; background: url(/static/assets/ico/twitter_fave.png) no-repeat; background-position: 0 0;
// }
// .imgIcons{
//   background-position: -3519px 0; transition: background 1s steps(55);
// }
// 自定义模式
.custom {
  display: flex;
  align-items: center;

  .custom-main {
    margin-right: 5px;
    display: flex;
    align-items: center;
    white-space: nowrap;

    .custom-menu {
      margin-right: 5px;
    }
  }
}

.el-tag.el-tag--success {
  background-color: rgba(19, 184, 135, 0.15);
}

.el-tag.el-tag--danger {
  background-color: rgba(235, 77, 92, 0.15);
}

.exchange-pc {
  position: relative;
  width: 600px;
  margin-right: 40px;
}

@keyframes slideup {
  0% {
    -webkit-transform: translateY(20%);
    transform: translateY(20%);
  }

  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes slidedown {
  0% {
    -webkit-transform: translateY(-20%);
    transform: translateY(-20%);
  }

  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

.home-download .img {
  width: 260px;
}

.animation_up {
  transition: all 0.8s ease-out 0.3s;
  animation: ease slideup 1s;
}

.animation_down {
  transition: all 0.8s ease-out 0.3s;
  animation: ease slidedown 1s;
}

.home_main {
  box-shadow: 0 0 42px 0 rgba(9, 30, 55, 0.06);
  //   padding: 20px 10px;
  margin-bottom: 30px;
  margin-top: 30px;
  min-height: 300px;
  /*min-width: 1080px;*/
  /*white-space: nowrap;*/
  /*overflow: hidden;*/

  /deep/ .el-table .cell {
    padding: 0 5px;
  }

  /deep/ tr.cell_style {
    cursor: pointer !important;
  }
}

.iconCoin {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: sub;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}

.At_the_bottom {
  // background-color: #fff !important;
}

.carousel {
  background: #101929 linear-gradient(336deg, #142547 0, #101929 100%);
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.coin-app {
  background-color: rgba(13, 14, 14, 0.75);
  padding: 10px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.app-info p {
  margin: 0;
  padding: 4px 0;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-info {
  line-height: 1.5;
  color: #fff;
  font-size: 14px;
  text-align: left;
}

.app-btn {
  margin-top: 20px;
}

.app-close {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  background-color: #409eff;
  text-align: center;
  color: #fff;
  position: absolute;
  top: -12px;
  right: 15px;
  z-index: 1000;
  cursor: pointer;
}

.app-info .logo {
  width: 50px;
  height: 50px;
  padding: 5px;
  // background: url("/images/mobile/mobileBg.png")center center no-repeat;
  background-size: 100%;
  overflow: hidden;
  float: left;
  border-radius: 10px;
  box-shadow: 0 5px 5px #333;
  margin-right: 10px;
  background: linear-gradient(180deg, #02aff1, #0268fd);

  .app-logo {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/tickers.vue